(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('AuthLoginCtrl', AuthLoginCtrl)
        .controller('AuthSignupCtrl', AuthSignupCtrl)
        .controller('AuthForgotCtrl', AuthForgotCtrl)
    ;

    /* @ngInject */
    function AuthLoginCtrl($state, CONFIG, SETTINGS, $http, AuthFactory) {

        var authvm = this;

        authvm.form = {username: '', password: ''};
        authvm.error = '';
        authvm.form.submitForm = submitForm;

        function submitForm() {

            if (SETTINGS.AUTH.TYPE === 'token' && CONFIG.ENV !== 'dev') {

                /**
                 * delete any existing token when the user submits the login form.
                 * if existing token exists and successful authentication they get refreshed
                 * token, otherwise if incorrect credentials entered the jwt is removed
                 */
                AuthFactory.setToken(false);

                $http.post(SETTINGS.AUTH.LOGIN_URL, authvm.form).then(function (response) {

                    AuthFactory.setToken(response.data.token);
                    $state.go(SETTINGS.AFTER_AUTH_STATE);

                }, function (error) {

                    if (error.status == -1) {
                        authvm.error = 'Could not connect to the server'
                    } else if (error.status == 401) {
                        authvm.error = 'Incorrect username or password'
                    } else {
                        authvm.error = error.data.errors[0].message;
                    }
                });
            } else {
                $state.go(SETTINGS.DEFAULT_STATE);
            }
        }
    }

    /* @ngInject */
    function AuthSignupCtrl($state, SETTINGS, App) {

        var authvm = this;

        authvm.form = {email: '', password: ''};
        authvm.error = '';
        authvm.submitForm = submitForm;

        function submitForm() {

            App.signup(authvm.form).then(function () {
                $state.go(SETTINGS.AFTER_AUTH_STATE);
            });
        }
    }

    /* @ngInject */
    function AuthForgotCtrl($state, SETTINGS, App) {

        var authvm = this;

        authvm.form = {email: ''};
        authvm.error = '';
        authvm.submitForm = submitForm;

        function submitForm() {

            App.forgot(authvm.form).then(function () {
                $state.go(SETTINGS.AFTER_AUTH_STATE);
            });
        }
    }
})();